export default __webpack_public_path__ + "static/beige-nr-a0f20efff6d913a57ebacffa817e061b.png";